<div class="model-security-allocations-chart">
    <div class="block">
        <div class="chart">
            <p-chart type="doughnut" [data]="chartData" [options]="options"
                     width="250px" height="250px"></p-chart>
        </div>
    </div>

    <div *ngIf="categoryTargetPercent && categoryTargetPercent.length !== 0">
        <div class="model-security-allocations-chart-custcat">By {{categoryLabel}}</div>
        <div>
            <div *ngFor="let lst of objectOfCategoryLists.lists;" class="model-security-allocations-chart-list">
                <div *ngFor="let item of lst;" class="model-security-allocations-chart-item">
                    <div class="model-security-allocations-chart-custcat-color" [style.backgroundColor]="getColorByCategory(item.category)"></div>
                    <div class="model-security-allocations-chart-item-category">{{item.category}}</div>
                    <div class="model-security-allocations-chart-item-target">{{item.targetPercent}}
                        %
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
